// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const regigigas: PokeData = {
  "id": 486,
  "name": "regigigas",
  "height": 37,
  "weight": 4200,
  "base_experience": 302,
  "types": [
    PokeType.NORMAL
  ],
  "api_moves": [
    "pound",
    "mega-punch",
    "fire-punch",
    "ice-punch",
    "thunder-punch",
    "stomp",
    "tackle",
    "confuse-ray",
    "dizzy-punch",
    "protect",
    "foresight",
    "ancient-power",
    "rock-smash",
    "facade",
    "superpower",
    "revenge",
    "knock-off",
    "hammer-arm",
    "payback",
    "giga-impact",
    "zen-headbutt",
    "iron-head",
    "crush-grip",
    "wide-guard",
    "heavy-slam",
    "bulldoze",
    "body-press"
  ],
  "moves": [
    "fire-punch",
    "ice-punch",
    "thunder-punch",
    "tackle",
    "confuse-ray",
    "protect",
    "ancient-power",
    "rock-smash",
    "superpower",
    "zen-headbutt",
    "tri-attack",
    "body-slam",
    "leer"
  ],
  "evolution_chain": {
    "id": 247,
    "item": null,
    "species": [
      {
        "name": "regigigas",
        "order": 487,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 119,
    "speed": 108,
    "ability_power": 173
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
